<template>
    <div class="cy-panel">
        <div class="graph">
            <p align="right" style="margin-right: 10px">Powered by <a href="https://js.cytoscape.org/" target="_blank">Cytoscape.js</a></p>
            <div class="cy" id="cyto" ref="cyto">
            </div>
            <div class="controls">
                <div class="interactionFilter">
                    <div>Show the following interaction types:</div>
                    <div>
                        <button class="default" v-bind:class="{ selected: selectAll }" v-on:click="clickAll">All</button>
                        <button class="genetic" v-bind:class="{ selected: selectGenetic }" v-on:click="clickGenetic">Genetic</button>
                        <button class="physical" v-bind:class="{ selected: selectPhysical }" v-on:click="clickPhysical">Physical</button>
                        <button class="regulatory" v-bind:class="{ selected: selectRegulatory }" v-on:click="clickRegulatory">Regulatory</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  // reference: Yo Yehudi's intermine widget
  // Widget to allow intermine gene interactions to be viewed using cytoscape.js
  // https://github.com/yochannah/cytoscape-intermine

  // hkmoon change the behavior to adopt the phenobank dataset

  import cytoscape from 'cytoscape';
  const _ = require('lodash');
  let cyto = null;
  let hiddenElements;

  export default {
    name: "Cyto.vue",
    props: ['master_gene', 'interacting_genes', 'show'],
    data() {
      return {
        selectAll: true,
        selectGenetic: false,
        selectPhysical: false,
        selectRegulatory: false
      }
    },
    methods: {
      clickAll() {
        const vm = this;
        vm.selectAll = true;
        vm.selectGenetic = vm.selectPhysical = vm.selectRegulatory = false;
        vm.filterElements('default');
      },
      clickGenetic() {
        const vm = this;
        vm.selectGenetic = true;
        vm.selectAll = vm.selectPhysical = vm.selectRegulatory = false;
        vm.filterElements('Genetic');
      },
      clickPhysical() {
        const vm = this;
        vm.selectPhysical = true;
        vm.selectAll = vm.selectGenetic = vm.selectRegulatory = false;
        vm.filterElements('Physical');
      },
      clickRegulatory() {
        const vm = this;
        vm.selectRegulatory = true;
        vm.selectAll = vm.selectPhysical = vm.selectGenetic = false;
        vm.filterElements('Regulatory');
      },
      filterElements(elemClass) {
        //old ones back:
        if (hiddenElements) {
          hiddenElements.restore();
        }
        //we have elemClass, and want to keep them, but hide the others.
        //new ones gone:
        hiddenElements = cyto.elements().filterFn(function(ele) {
          if (elemClass === 'default') {
            return !ele;
          }
          return (!ele.hasClass(elemClass) && !ele.hasClass('both') && !ele.hasClass('master'));
        }).remove();
      },
      formatData: function(master_gene, genes) {
        let geneList = genes.split(', ')
        const nodes = []
        const edges = []

        nodes.push({
          'classes': 'master',
          'data': {
            'title': 'Gene ' + master_gene,
            'label': master_gene,
            'class': 'Gene',
            'interactionTypes': ['master'],
            'symbol': master_gene,
            'id': master_gene
          }
        })

        _.each(geneList, item => {
          let tokens = item.split('(')
          let gene = tokens[0]
          let type = tokens[1].replace(')', '')
          let types = type.split('|')

          nodes.push({
            'classes': type,
            'data': {
              'title': 'Gene ' + gene,
              'label': gene,
              'class': 'Gene',
              'interactionTypes': types,
              'symbol': gene,
              'id': gene
            }
          })

          edges.push({
            'classes': type,
            'data':{
              'id': gene + '_' + type,
              'title': 'Interaction between ' + master_gene + ' and ' + gene,
              'source': master_gene,
              'target': gene,
              'interactionType': types.length > 1 ? 'both': type
            }
          })
        })

        return { nodes, edges }
      },
      renderView: function(master_gene, genes) {
        const vm = this
        cyto = cytoscape({
          container: this.$refs.cyto,
          elements: vm.formatData(master_gene, genes),
          style: [{
            "selector": "node",
            "style": {
              "content": "data(label)",
              "border-width": "2px",
              "background-color": "#dedede",
              "border-style": "solid",
              "border-color": "#999"
            }
          }, {
            "selector": ":selected",
            "style": {
              "text-outline-color": "black",
              "background-color": "gold",
              "border-color": "gold",
              "border-width": "5px",
              "border-style": "solid"
            }
          }, {
            "selector": "edge",
            "style": {
              "width": "2px"
            }
          }, {
            "selector": "edge[interactionType@^=\"genetic\"]",
            "style": {
              "line-color": "#2c79be"
            }
          }, {
            "selector": "edge[interactionType@^=\"physical\"]",
            "style": {
              "line-color": "#c00"
            }
          }, {
            "selector": "edge[interactionType@^=\"regulatory\"]",
            "style": {
              "line-color": "#00c000"
            }
          }, {
            "selector": ".Genetic",
            "style": {
              "border-color": "#225f95"
            }
          }, {
            "selector": ".Physical",
            "style": {
              "border-color": "#c00"
            }
          }, {
            "selector": ".Regulatory",
            "style": {
              "border-color": "#00c000"
            }
          }, {
            "selector": ".both",
            "style": {
              "border-color" : "#77304B"
            }
          }],
          layout: {
            name: 'cose',
            refresh: 20,
            animate: false,
            stop: function() {
              vm.$emit('update:show', true)
            }
          },
          ready: function() {
            // const targetElem = vm.$refs.cyto;
            // Make the graph as wide as can be. can't be auto as cytoscape needs a width
            // targetElem.style.width = targetElem.parentElement.clientWidth - 200 + "px";
          }
        }),

        //event listener for node taps
        cyto.on('tap', 'node', function() {
          // console.log(this.data())
          window.open('https://wormbase.org/search/gene/' + this.data().label, '_blank');
        });

        // cyto.on('tap', 'edge', function() {
        //   console.log(this.data())
        // });
      }
    },
    mounted: function() {
      const vm = this;
      vm.renderView(vm.master_gene, vm.interacting_genes);
    }
  }
</script>

<style scoped>
    .cy-panel {
        display: flex;
        background-color: #f0f0f0;
        flex-wrap: wrap;
        border: solid 1px #eee;
        margin-bottom: 10px;
    }

    .cy-panel .graph {
        border: solid 1px #eee;
        background-color: white;
        min-width: 600px;
        min-height: 500px;
        flex-direction: row;
        margin: 1em;
        border-radius: 4px;
        flex-grow: 1;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        font-size: 0.9em;
    }
    .cy-panel .cy {
        width: 600px;
        height: 500px;
        margin: auto;
    }

    .cy-panel .controls {
        padding: 0;
        margin: auto;
    }
    .cy-panel .controls .interactionFilter {
        text-align: center;
    }
    .cy-panel .controls button {
        background-color: #eee;
        border: 0;
        border-bottom: solid 3px #fff;
        padding: 0.5em 1.5em;
        color: #000;
        margin: 0;
        transition: border 1s ease;
        position: relative;
    }
    .cy-panel .controls button:before {
        content: "";
        width: 15px;
        height: 15px;
        margin-right: 0.5em;
        display: block;
        float: left;
        opacity: 0.4;
        border-radius: 30px;
        border: solid 2px #eee;
    }
    .cy-panel .controls button.selected:before {
        opacity: 1;
    }
    .cy-panel .controls button.genetic:before {
        border-color: #225f95;
    }
    .cy-panel .controls button.default:before {
        border-color: #77304B;
    }
    .cy-panel .controls button.physical:before {
        border-color: #c00;
    }
    .cy-panel .controls button.regulatory:before {
        border-color: #00c000;
    }
    .cy-panel .controls button:after {
        display: block;
        position: absolute;
        left: 0;
        bottom: -3px;
        width: 0;
        height: 3px;
        background-color: #ec971f;
        content: "";
        transition: width 0.2s;
    }
    .cy-panel .controls button:hover:after {
        width: 100%;
    }
    .cy-panel .controls button.selected {
        transition: border 1s ease;
        border-bottom: solid 3px #2c79be;
    }
    .cy-panel .controls button:first-child {
        -webkit-border-top-left-radius: 4px;
        -webkit-border-bottom-left-radius: 4px;
        -moz-border-radius-topleft: 4px;
        -moz-border-radius-bottomleft: 4px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        border-right: solid 1px #d5d5d5;
        margin: 0;
    }
    .cy-panel .controls button:last-child {
        margin: 0;
        border-left: solid 1px #d5d5d5;
        -webkit-border-top-right-radius: 4px;
        -webkit-border-bottom-right-radius: 4px;
        -moz-border-radius-topright: 4px;
        -moz-border-radius-bottomright: 4px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

</style>